<template>
  <div style="margin-top: 22px">
    <el-row :gutter="24">
      <el-col :span="12">
        <div class="contentBox">
          <div class="title" center />
        </div>
        <div style="height:390px;">
          <h2 style="text-align: center;margin-top: 10px;">最新任务</h2>
          <div style="height:390px;color: #878A8F" v-if="!showLastestTask">
            <el-table border style="margin-top: 22px;">
              暂无数据
            </el-table>
          </div>
          <el-form ref="form" :model="form" label-width="100px" v-if="showLastestTask">
            <el-row>
              <el-col :gutter="24" :span="22">
                <el-form-item label="任务名称：" prop="taskName">
                  <div>{{ form.taskName }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="22">
                <el-form-item label="完成时间：" prop="finishTime">
                  <div>{{ form.finishTime | dateFomat }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="22">
                <el-form-item label="任务内容：" prop="taskContent">
                  <div class="innerHtmlDiv" ref="taskContent" />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="contentBox">
          <div class="title" />
        </div>
        <div>
          <h2 style="text-align: center;margin-top: 10px;">往期任务</h2>
          <el-table :data="tabledata" class="noPadding" max-height="350">
            <el-table-column prop="taskName">
              <template slot-scope="scope">
                <el-button @click="showTaskDetail(scope.row)" type="text" style="color: #111111;margin-left: 20px">
                  {{ scope.row.taskName }}
                </el-button>
              </template>
            </el-table-column>
            <el-table-column prop="taskContent" v-if="false" />
            <el-table-column prop="finishTime" v-if="false" />
          </el-table>
        </div>
        <el-dialog :title="taskTitle" :visible.sync="taskDetailVisiable" width="40%" center>
          <el-form ref="form" :model="taskDetailDialog" label-position="center">
            <el-row>
              <el-col :gutter="24" :span="24">
                <el-form-item label="任务名称：" prop="taskName">
                  <div>{{ taskDetailDialog.taskName }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="完成时间：" prop="finishTime">
                  <div>{{ taskDetailDialog.finishTime | dateFomat }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="任务内容：" prop="taskContent">
                  <div ref="taskContent1" />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="taskDetailVisiable = false">关闭</el-button>
          </div>
        </el-dialog>
      </el-col>
    </el-row>
    <el-row :gutter="24">
      <h2 style="text-align: center;margin-top: 10px;margin-bottom: 20px">相关法律法规</h2>
      <el-col :span="12">
        <template v-for="(law,index) in lawTableData">
          <div v-if="index<=4" :key="index" style="padding: 2px;">
            <el-button type="text" style="color: #000000"><a :href="`api/common/file/${law.attachmentId}`" target="_blank">{{ law.title }}</a></el-button>
          </div>
        </template>
      </el-col>
      <el-col :span="12">
        <template v-for="(law,index) in lawTableData">
          <div v-if="index>4" :key="index" style="padding: 2px;">
            <el-button type="text" style="color: #000000"><a :href="`api/common/file/${law.attachmentId}`" target="_blank">{{ law.title }}</a></el-button>
          </div>
        </template>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <div class="block" style="text-align: right;margin-top: 20px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page.current"
            :page-size="page.size"
            layout="total, prev, pager, next, jumper"
            :total="page.total"
          />
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import API from '../../api';
import { merge } from '../../utils';
import { formate } from '../../utils/mixin';

export default {
  name: 'HomePage',
  mixins: [formate],
  data () {
    return {
      form: {
        taskName: '',
        finishTime: '',
        taskContent: ''
      },
      tabledata: [],
      lawTableData: [],
      page: {
        total: 10,
        size: 10,
        current: 1
      },
      taskDetailVisiable: false,
      taskDetailDialog: {
        taskName: '',
        finishTime: ''
      },
      taskTitle: '',
      showLastestTask: true
    };
  },
  filters: {
    dateFomat (time) {
      let date = new Date(time);
      return formate.methods.getUTCtime(date);
    }
  },
  mounted () {
    this.init();
  },
  methods: {
    init () {
      this.getNewSysTask();
      this.getPastPeriodSysTaskList();
      this.getLawNewList();
    },
    getNewSysTask () {
      API.getNewSysTask().then((res) => {
        let json = res.data;
        if (json.status == '200') {
          this.form = merge({}, this.form, json.data);
          if (json.data === null || JSON.stringify(json.data) === '{}') {
            this.showLastestTask = false;
          }
          this.$refs.taskContent.innerHTML = json.data.taskContent;
        }
      }).catch(() => {

      });
    },
    getPastPeriodSysTaskList () {
      API.getPastPeriodSysTaskList().then((res) => {
        let json = res.data;
        if (json.status == '200') {
          this.tabledata = json.data;
        }
      }).catch(() => {

      });
    },
    getLawNewList () {
      let params = {
        params: {
          pageNum: this.page.current,
          pageSize: this.page.size
        }
      };
      API.getLawNewList(params)
        .then(res => {
          let json = res.data;
          if (json.status == '200') {
            let page = res.data.data;
            this.page.total = Number(page.total);
            this.lawTableData = page.list;
          } else {
          }
        }).catch(() => {
          console.error('err', e);
        });
    },
    downloadFile (row) {
      let downloadPath = window.location.origin + API.axios.defaults.baseURL + 'common/file/';
      API.axios.get(downloadPath + row.attachmentId);
    },
    handleSizeChange (val) {
      this.page.size = val;
      this.getLawNewList();
    },
    handleCurrentChange (val) {
      this.page.current = val;
      this.getLawNewList();
    },
    showTaskDetail (row) {
      this.taskDetailVisiable = true;
      this.taskTitle = row.taskName;
      this.taskDetailDialog.taskName = row.taskName;
      this.taskDetailDialog.finishTime = new Date(row.finishTime);
      let that = this;
      setTimeout(function () {
        that.$refs.taskContent1.innerHTML = row.taskContent;
      }, 100);
    }
  }
};
</script>

<style>
  .noPadding td, .noPadding th {
    padding: 2px;
  }
  .innerHtmlDiv {
    height: 300px;
    width: 470px;
    /*border: 1px solid #304156;*/
    overflow: hidden;
  }
</style>
